export default (props) => {
  const { role, user, children } = props

  return role === user.info.role ? children : null
}



// WEBPACK FOOTER //
// ./src/components/Layout/Render/Render.jsx